<div class="column spacing-24 edit-toggle-page" style="margin-bottom: 64px">
	<div class="content-container">
		<div class="content-container-header role-header-flex">
			<h3 class="flex-grow" style="margin-top: 16px" i18n="@@roleDetailCapabilities-RoleName">Role Name</h3>

			@if (this.canEditRoles && !this.isEditing && !this.editButtonDisabled) {
				<div class="spacing-24 flex-fixed">
					<button
						mat-button
						i18n="@@roleDetailCapabilities-detailEditButton"
						class="primary-button"
						(click)="isEditing = true"
						data-automation-id="role-detail-capabilities-edit-button"
					>
						Edit
					</button>
				</div>
			}
			@if (this.isEditing) {
				<div class="spacing-24 flex-fixed flex-row">
					<button
						mat-button
						i18n="@@roleDetailCapabilities-detailCancel"
						class="secondary-button"
						(click)="onCancelClicked()"
						data-automation-id="role-detail-capabilities-cancel-button"
					>
						Cancel
					</button>
					<button
						mat-button
						i18n="@@roleDetailCapabilities-detailSaveChanges"
						class="primary-button"
						[disabled]="!isValid()"
						(click)="onSaveEditsClicked()"
						data-automation-id="role-detail-capabilities-save-changes-button"
					>
						Save Changes
					</button>
				</div>
			}
		</div>

		<mat-divider></mat-divider>

		<div class="content-container-body column spacing-24">
			<!-- View mode -->

			@if (!this.isEditing) {
				<div class="row">
					<div class="flex-5">
						<div class="row top-bottom-padding">
							<table style="width: 100%">
								<tr class="mat-body-2">
									<td class="width-25-grey" i18n="@@roleDetailCapabilities-Name">Name</td>
								</tr>
								<tr class="mat-body-3">
									<td class="table-body-text">{{ this.editRoleName }}</td>
								</tr>
							</table>
						</div>
					</div>
				</div>
			}

			<!-- Edit mode -->

			@if (this.isEditing) {
				<div class="row">
					<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
						<mat-label i18n="@@roleDetailCapabilities-Name">Name</mat-label>
						<input
							matInput
							[(ngModel)]="this.editRoleName"
							[disabled]="!this.isEditing"
							data-automation-id="role-name-input"
							required
						/>
					</mat-form-field>
				</div>
			}
		</div>
	</div>

	<app-system-capability-table
		[mode]="this.mode()"
		[companyId]="companyId"
		[companyType]="companyType"
		[roleName]="this.editRoleName"
		[systemCapabilityItems]="this.editItems"
		[showRoleName]="false"
		[showSubtitle]="false"
		(systemCapabilitiesToggleEvents)="onSystemCapabilityToggleEvent($event)"
	>
	</app-system-capability-table>
</div>
